/**
 * @todo
 * enable strict mode and fix the fucking mutation issue...
 */
export const strict = false

export const actions = {}
